<div class="autocomplete">
  <app-input id="lead-autocomplete-{{id}}" 
    label="Nome ou apelido" 
    maxlength="180" 
    [formControl]="requestAutocomplete" 
    placeholder="Buscar participantes" 
    [loading]="loading" 
    [error]="error || isError" 
    [messageError]="messageError">
  </app-input>

  <ul class="list-autocomplete" *ngIf="open && list.length" [ngClass]="{'input-error': error}">
    <li class="item-autocomplete" *ngFor="let item of list; let last = last">
      <a class="action-autocomplete" [ngClass]="{'no-border': last}" (click)="checkNewParticipant(item)">
        <p [innerHTML]="item.label"></p>
      </a>
    </li>
  </ul>
</div>